import noop from "lodash/noop";
import { compose } from "redux";
import debounce from "lodash/debounce";
import React, { PureComponent, createRef } from "react";
import Close from "@material-ui/icons/Close";
import Search from "@material-ui/icons/Search";
import { withStyles } from "@material-ui/core/styles";
import {
  TextField,
  InputAdornment,
  Paper,
  Grid,
  IconButton,
} from "@material-ui/core";

import { invokeIfFunction } from "utils/app.util";

class SearchField extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };

    this.inputRef = props.inputRef || createRef();
  }

  componentDidMount() {
    const { onChange, timeout } = this.props;
    this.onChangeDebounced = debounce(onChange, timeout);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({
        value: this.props.value,
      });
    }
  }

  onChange = event => {
    const { onKeyDown } = this.props;

    invokeIfFunction(onKeyDown, event.target.value);
    this.setState({ value: event.target.value });
    this.onChangeDebounced(event.target.value);
  };

  onClear = () => {
    const { onClear } = this.props;

    this.setState({ value: "" });
    this.onChangeDebounced("");

    invokeIfFunction(onClear);

    this.onFocus();
  };

  onFocus = () => {
    if (this.inputRef.current) this.inputRef.current.focus();
  };

  render() {
    const { classes, TextFieldProps, InputProps } = this.props;

    return (
      <Grid
        container
        component={Paper}
        justifyContent="center"
        direction="column"
        onClick={this.onFocus}
        className={classes.root}
      >
        <TextField
          margin="none"
          inputRef={this.inputRef}
          placeholder="Search..."
          value={this.state.value}
          onChange={this.onChange}
          InputProps={{
            disableUnderline: true,
            classes: {
              input: classes.input,
            },
            endAdornment: (
              <InputAdornment>
                <IconButton size="medium" onClick={this.onClear}>
                  {this.state.value && this.inputRef ? (
                    <Close fontSize="small" />
                  ) : (
                    <Search fontSize="small" />
                  )}
                </IconButton>
              </InputAdornment>
            ),
            ...InputProps,
          }}
          {...TextFieldProps}
        />
      </Grid>
    );
  }
}

SearchField.defaultProps = {
  timeout: 500,
  onChange: noop,
};

const styles = theme => ({
  root: {
    cursor: "text",
    background: "white",
    boxShadow: theme.shadows[1],
    paddingLeft: theme.spacing(1),
    height: theme.spacing(5),
  },
  input: {
    padding: 0,
  },
});

export default compose(withStyles(styles))(SearchField);
